/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spicy_Lower_Termite_RelishInputs */

const fr_spicy_lower_termite_relish = /** @type {(inputs: Spicy_Lower_Termite_RelishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois un programme acheté, il sera visible ici.`)
};

/**

* @param {Spicy_Lower_Termite_RelishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spicy_lower_termite_relish = /** @type {((inputs?: Spicy_Lower_Termite_RelishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spicy_Lower_Termite_RelishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spicy_lower_termite_relish(inputs)
});